var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('run-cognitive-test',{attrs:{"dataNamespace":_vm.nodeId,"type":_vm.type,"parameters":_vm.parameters},on:{"back":_vm.onBack,"end":_vm.onEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }